import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { RedefinirSenhaRoutingModule } from "./redefinir-senha-routing.module";
import { RedefinirSenhaComponent } from "./redefinir-senha.component";
import { AntdModule } from "../../antd.module";
import { ReactiveFormsModule } from "@angular/forms";
import { InputMaskModule } from "@ngneat/input-mask";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
    declarations: [RedefinirSenhaComponent],
    imports: [
        CommonModule,
        RedefinirSenhaRoutingModule,
        AntdModule,
        ReactiveFormsModule,
        InputMaskModule,
        SharedModule,
    ],
})
export class RedefinirSenhaModule {}
